import { render, staticRenderFns } from "./BackToTopForDialog.vue?vue&type=template&id=90a73d80&scoped=true&"
import script from "./BackToTopForDialog.vue?vue&type=script&lang=js&"
export * from "./BackToTopForDialog.vue?vue&type=script&lang=js&"
import style0 from "./BackToTopForDialog.vue?vue&type=style&index=0&id=90a73d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a73d80",
  null
  
)

export default component.exports